// Locally-stored recordings are stamped with the creating user's id
// (`userId: authState.userSub`). IndexedDB is not cleared on logout, so on a
// shared browser one account's rows can linger into another account's session.
// These helpers keep the UI scoped to the signed-in user.

/**
 * Whether a locally-stored row should be visible to the current user. Rows owned
 * by a *different* user are hidden (shared-browser privacy). Null-owner rows
 * (offline drafts created before auth resolved) and every row while the current
 * user is still unknown are kept, so a user never loses sight of their own work.
 * Pairs with clear-on-user-switch, which removes other users' rows from storage.
 */
export function isVisibleToUser(
  rowUserId: string | null | undefined,
  currentUserId: string | null,
): boolean {
  if (!currentUserId) return true
  if (rowUserId == null) return true
  return rowUserId === currentUserId
}
